module.exports = __webpack_public_path__ + "static/media/book-gray.1952321d.svg";